import React from "react";
import lang from "translations";

// Standard dependency-free "print only this element" trick: on @media print, hide
// everything in the document, then force-show just this element (display:block
// !important overrides the on-screen display:none). No react-to-print/window.print
// pattern existed anywhere in the app to reuse -- confirmed via codebase search.
const PRINT_STYLE = `
@media print {
  body * { visibility: hidden; }
  #printable-bill-root, #printable-bill-root * { visibility: visible; }
  #printable-bill-root { display: block !important; position: absolute; left: 0; top: 0; width: 100%; padding: 24px; }
}
`;

const row = (label, value, strong) => (
  <div style={{ display: "flex", justifyContent: "space-between", padding: "2px 0" }}>
    <span>{label}</span>
    <span style={{ fontWeight: strong ? 700 : 400 }}>{value}</span>
  </div>
);

const PrintableBill = ({ bill, venueName }) => {
  if (!bill) {
    return <style>{PRINT_STYLE}</style>;
  }

  return (
    <div id="printable-bill-root" style={{ display: "none", fontFamily: "sans-serif", fontSize: 13, color: "#000" }}>
      <style>{PRINT_STYLE}</style>
      <h2 style={{ marginBottom: 0 }}>{venueName}</h2>
      <div style={{ marginBottom: 16 }}>
        {lang.bill} #{bill.billHeaderId} · {bill.status}
      </div>

      {row(lang.openedAt, bill.openedAt)}
      {row(lang.settledAt, bill.settledAt)}

      <hr style={{ margin: "12px 0" }} />

      {bill.splits.map((split) => (
        <div key={split.billSplitId} style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>
            {lang.splitNumber} {split.splitNumber} ({split.splitType})
          </div>
          {split.items.map((item) => (
            <div key={item.itemId} style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{item.productName} × {item.quantity}</span>
              <span>{item.amount}</span>
            </div>
          ))}
          {split.payments.map((payment) => (
            <div key={payment.transactionId || payment.referenceId} style={{ color: "#555", display: "flex", justifyContent: "space-between" }}>
              <span>{payment.method} ({payment.status})</span>
              <span>{payment.amount}</span>
            </div>
          ))}
        </div>
      ))}

      <hr style={{ margin: "12px 0" }} />

      {row(lang.grossAmount, bill.grossAmount)}
      {row(lang.discountAmount, bill.discountAmount)}
      {row(lang.voucherAmount, bill.voucherAmount)}
      {row(lang.taxAmount, bill.taxAmount)}
      {row(lang.netAmount, bill.netAmount)}
      {row(lang.paidAmount, bill.paidAmount, true)}
    </div>
  );
};

export default PrintableBill;
